var actionTypes = require('../../../actionTypes.js');

module.exports.createAction = (payload)=> (
            {
                type: actionTypes.alertDialogueUI,
                payload: payload
            }
           )

module.exports.changeState = (previousState, payload)=> Object.assign({}, previousState, {alertDialogue: payload})